import './index.scss';
import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { changeToManageMode } from '../../../js/actions/appModeActionCreators';
import { dismissGettingStarted } from '../../../js/actions/gettingStartedActionCreators';
import generateInstallerLink from '../../../js/serverApi/installerLinkGenerator';
import { hasValidLicence } from '../../../js/projections/licence';
import ManagePageLayout from '../../common/PageLayout/Manage';
import AgentsIcon from '../../../icons/getting-started/agents.png';
import ImageIcon from '../../../icons/getting-started/image.png';
import CloneIcon from '../../../icons/getting-started/clone.png';

const GettingStartedPage = React.createClass({
    propTypes: {
        alignMode: PropTypes.func.isRequired,
        canCreate: PropTypes.bool.isRequired,
        hasAgents: PropTypes.bool.isRequired,
        hasImage: PropTypes.bool.isRequired,
        setGettingStartedAsDismissed: PropTypes.func.isRequired
    },
    componentDidMount: function () {
        this.props.alignMode();
    },
    getInitialState: function() {
        return {
            installerLink: generateInstallerLink()
        };
    },
    render: function () {
        const { installerLink } = this.state;
        const { hasAgents, canCreate, hasImage, setGettingStartedAsDismissed } = this.props;
        return (
            <ManagePageLayout>
                <div className="pure-g Getting-started-page">
                    <div className="pure-u-1-1">
                        <h1>Getting started</h1>

                        <ol>
                            <li className="media">
                                <img src={AgentsIcon} className="media__image"/>
                                <div className="media__body">
                                    <h2>Install agents</h2>
                                    <p>Agents help SQL Clone in two ways: to access the database you’d like to clone and provide clones to machines that use them.</p>

                                    <ul className="agents-list">
                                        <li>Install an agent where the database you would like to clone is located. This can be on a SQL Server instance running a database or a SQL Server instance that can restore a backup.</li>
                                        <li>Install an agent on a machine that will use clones.</li>
                                    </ul>

                                    <div className="notice">
                                        <p>You need to download a new agent for each machine.</p>
                                    </div>

                                    <a href={installerLink} className="button button--primary">Download agent</a>
                                </div>
                            </li>

                            <li className="media">
                                <img src={ImageIcon} className="media__image"/>
                                <div className="media__body">
                                    <h2>Create an image</h2>
                                    <p>We first make a read-only copy of your database called an image. This should be in a shared location so your team can start making clones from it.</p>
                                    
                                    {(hasAgents && canCreate) ?
                                        <Link to="/images/create/setup" className="button button--primary">Create image</Link> :
                                        <button className="button button--primary button--disabled" disabled>Create image</button>}
                                </div>
                            </li>

                            <li className="media">
                                <img src={CloneIcon} className="media__image"/>
                                <div className="media__body">
                                    <h2>Start cloning</h2>
                                    <p>Once you have an image, you can start creating clones very quickly!</p>
                                    
                                    {(hasImage && canCreate) ? 
                                        <Link to="/clones/create/source" className="button button--primary">Create clone</Link> : 
                                        <button className="button button--primary button--disabled" disabled>Create clone</button>}
                                </div>
                            </li>
                        </ol>

                        <hr/>
                        <Link to="/dashboard" onClick={setGettingStartedAsDismissed}>I'll do this later</Link>
                    </div>
                </div>
            </ManagePageLayout>
        );
    }
});

const mapStateToProps = (state) => {
  return {
    canCreate: hasValidLicence(state),
    hasImage: state.images.value.size > 0,
    hasAgents: state.agents.value.size > 0
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    alignMode: () => {
      dispatch(changeToManageMode());
    },
    setGettingStartedAsDismissed: () => {
        dispatch(dismissGettingStarted());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GettingStartedPage);



// WEBPACK FOOTER //
// ./src/components/home/GettingStartedPage/index.jsx